import { createContext, useContext, useMemo } from "react";

import { Injector } from "vistar/honk-di";

const InjectorContext = createContext(new Injector());

export function useInjector(): Injector {
  return useContext(InjectorContext);
}

export const InjectorProvider = InjectorContext.Provider;

export function useInjected<
  Constructor extends new (
    ...args: any[]
  ) => unknown,
>(value: Constructor): InstanceType<Constructor>;
export function useInjected<Instance>(value: unknown): Instance;
export function useInjected(value: unknown) {
  const injector = useInjector();
  const instance = useMemo(() => {
    return injector.getInstance(value);
  }, [injector, value]);

  return instance;
}
